module.exports = __webpack_public_path__ + "img/dropdown-clip-maker.25507438.png";